import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c245edc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["model"]
const _hoisted_2 = { class: "wrap_header" }
const _hoisted_3 = {
  key: 0,
  class: "menubar"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-send",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Gởi tin nhắn")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-upload",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Đăng hình ảnh")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-bars",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Nhân viên nhận báo cáo")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-dollar",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Nhân viên nhận thông báo CK")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-megaphone",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Nhân viên nhận TB té/ngã")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-list",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Danh sách đăng ký khám bệnh")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-user-plus",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Thêm nhân viên hỗ trợ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-users",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Danh sách nhân viên")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-users",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Quản lý nhóm")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-list-check",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Quản lý nghỉ phép")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-map-marker",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Cài đặt CheckIn")
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-cloud-download",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Nhận thông báo CheckIn")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-ellipsis-h",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Nhóm CheckIn")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-file-export",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Xuất dữ liệu CheckIn")
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-desktop",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_33 = /*#__PURE__*/_createTextVNode("CheckIn hộ")
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-send",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Gởi kết quả CLS")
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-user-plus",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Đăng ký tài khoản")
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-users",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Quản lý tài khoản")
const _hoisted_40 = {
  key: 1,
  class: "menubar"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-send",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Gởi kết quả CLS")
const _hoisted_43 = { class: "logouts" }
const _hoisted_44 = { style: {"font-size":"11px","color":"yellow","text-align":"center"} }
const _hoisted_45 = {
  key: 1,
  id: "fotter"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrap_header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "coppyi" }, "© Copyright 2024 - Trung tâm y tế Quận Ngũ Hành Sơn")
], -1))
const _hoisted_47 = [
  _hoisted_46
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($props.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "header",
          model: $setup.appMenu
        }, [
          _createElementVNode("div", _hoisted_2, [
            ($setup.permission&&!$setup.cls)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/sendmessage" }, {
                        default: _withCtx(() => [
                          _hoisted_4,
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/uploadImage" }, {
                        default: _withCtx(() => [
                          _hoisted_6,
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/addReceiverReportPage" }, {
                        default: _withCtx(() => [
                          _hoisted_8,
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/addAccountantPage" }, {
                        default: _withCtx(() => [
                          _hoisted_10,
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/addReceiverFallPage" }, {
                        default: _withCtx(() => [
                          _hoisted_12,
                          _hoisted_13
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/listRegisterService" }, {
                        default: _withCtx(() => [
                          _hoisted_14,
                          _hoisted_15
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/addemployee" }, {
                        default: _withCtx(() => [
                          _hoisted_16,
                          _hoisted_17
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/showlistemployee" }, {
                        default: _withCtx(() => [
                          _hoisted_18,
                          _hoisted_19
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/managergroup" }, {
                        default: _withCtx(() => [
                          _hoisted_20,
                          _hoisted_21
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/showlistdayoff" }, {
                        default: _withCtx(() => [
                          _hoisted_22,
                          _hoisted_23
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/checkInGroup" }, {
                        default: _withCtx(() => [
                          _hoisted_24,
                          _hoisted_25
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/addManagerCheckinPage" }, {
                        default: _withCtx(() => [
                          _hoisted_26,
                          _hoisted_27
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/timeGroupPage" }, {
                        default: _withCtx(() => [
                          _hoisted_28,
                          _hoisted_29
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/showListCheckIn" }, {
                        default: _withCtx(() => [
                          _hoisted_30,
                          _hoisted_31
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/checkInByUserPage" }, {
                        default: _withCtx(() => [
                          _hoisted_32,
                          _hoisted_33
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/sendfile" }, {
                        default: _withCtx(() => [
                          _hoisted_34,
                          _hoisted_35
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/registerUser" }, {
                        default: _withCtx(() => [
                          _hoisted_36,
                          _hoisted_37
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, { to: "/userList" }, {
                        default: _withCtx(() => [
                          _hoisted_38,
                          _hoisted_39
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : ($setup.cls)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_RouterLink, { to: "/sendfile" }, {
                          default: _withCtx(() => [
                            _hoisted_41,
                            _hoisted_42
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_Button, {
                label: "Đăng xuất",
                onClick: $setup.logout,
                icon: "pi pi-sign-out",
                iconPos: "right",
                class: "p-button-secondary"
              }, null, 8, ["onClick"]),
              _createElementVNode("label", _hoisted_44, _toDisplayString($setup.currentTime.toLocaleTimeString('en-GB')) + " " + _toDisplayString($setup.currentTime.toLocaleDateString('en-GB')), 1)
            ])
          ])
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    ($props.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
      : _createCommentVNode("", true)
  ], 64))
}